import { cyan700, grey100, grey300,
          grey400, grey500, white } from 'material-ui/styles/colors';
import spacing from 'material-ui/styles/spacing';

const fullBlack = 'rgba(0, 0, 0, 1)';

export default {
  spacing: spacing,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    textColor: '#445981',
    primary1Color: '#1d3767', // Title color on input focus
    primary2Color: cyan700,
    primary3Color: grey400,
    accent1Color: '#445981',
    accent2Color: grey100,
    accent3Color: grey500,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: 'rgba(68, 89, 129, 0.75)', // Title color
    pickerHeaderColor: '#445981',
    clockCircleColor: fullBlack,
    shadowColor: fullBlack,
  }
};



// WEBPACK FOOTER //
// ./src/shared/theme.js